module.exports = __webpack_public_path__ + "img/occidental-room3.3a6aac02.jpg";